import Vue from "vue";
import { ToastPlugin, ModalPlugin } from "bootstrap-vue";
import VueCompositionAPI from "@vue/composition-api";

import router from "./router";
import store from "./store";
import App from "./App.vue";
import CryptoJS from "crypto-js";

// Global Components
import "./global-components";

// 3rd party plugins
import "@/libs/portal-vue";
import "@/libs/toastification";
import "@/libs/sweet-alerts";
// import "@/libs/vue-video-player";

//Vue Idle
import IdleVue from "idle-vue";
const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3600000, // 60 mins //1000*60*15, // 3 seconds
  startAtIdle: false,
});

// BSV Plugin Registration
Vue.use(ToastPlugin);
Vue.use(ModalPlugin);

// Composition API
Vue.use(VueCompositionAPI);

// import core styles
require("@core/scss/core.scss");

// import assets styles
require("@/assets/scss/style.scss");

Vue.config.productionTip = false;

Vue.directive("permission", {
  bind: function (el, binding, vnode) {
    // replace HTMLElement with comment node : https://stackoverflow.com/questions/43003976/a-custom-directive-similar-to-v-if-in-vuejs

    if (!store.getters["app/hasAccessMenuPermission"](binding.value)) {
      const comment = document.createComment(" ");
      Object.defineProperty(comment, "setAttribute", {
        value: () => undefined,
      });
      vnode.elm = comment;
      vnode.text = " ";
      vnode.isComment = true;
      vnode.context = undefined;
      vnode.tag = undefined;
      vnode.data.directives = undefined;

      if (vnode.componentInstance) {
        vnode.componentInstance.$el = comment;
      }

      if (el.parentNode) {
        el.parentNode.replaceChild(comment, el);
      }
    }
  },
});

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(Loading);

// Define your loader function
import { showCustomLoader } from "@/utils/customLoader";

// Make globally available in components
Vue.prototype.$showCustomLoader = showCustomLoader;

// Make available in Vuex store
store.$showCustomLoader = showCustomLoader;

import moment from "moment";
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("Do MMM, YYYY");
  }
});
Vue.filter("formatFullDateTime", function (value) {
  if (value) {
    return moment(String(value)).format("DD MMMM, YYYY hh:mm A");
  }
});
Vue.filter("formatLocalDateTime", function (value) {
  if (!value) return "";
  // Parse as UTC but don't convert to local time
  return moment.parseZone(value).format("DD MMMM, YYYY hh:mm A");
});
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("DD MMMM, YYYY");
  }
});

Vue.filter("formatTime", function (value) {
  if (value) {
    return moment(String(value), "HH:mm:ss").format("hh:mm A");
  }
});
Vue.filter("formatDateTimeSkipTimeIfZero", function (d) {
  var format = "DD/MM/YYYY h:mm:ss a";
  if (moment(d).startOf("day").valueOf() === moment(d).valueOf()) {
    format = "DD/MM/YYYY";
  }
  return moment(d).format(format);
});
Vue.filter("formatBDTNumber", function (value) {
  if (!value || isNaN(value)) return "0.00";

  const [integerPart, decimalPart] = Number(value).toFixed(2).split(".");
  const lastThree = integerPart.slice(-3);
  const otherNumbers = integerPart.slice(0, -3);

  const formattedInteger =
    otherNumbers !== ""
      ? otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + lastThree
      : lastThree;

  return formattedInteger + "." + decimalPart;
});
Vue.filter("formatNumber", function (value) {
  if (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
});

Vue.filter("numberWithCommas", function (value) {
  if (!value) return "";
  return value.toLocaleString();
});

Vue.filter("monthName", function (value) {
  if (value) {
    return moment(value, "MM").format("MMM");
  }
});

// only for string text
Vue.filter("limitString", function (value, limit) {
  if (!value) return "N/A";
  return value.length > limit ? value.slice(0, limit) + "..." : value;
});

Vue.filter("uppercase", function (str) {
  return str ? str.toUpperCase() : "";
});

import { printDiv } from "@core/utils/globalFunctions";

Vue.prototype.$printDiv = printDiv;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
